import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../../data/blogData';
import './BlogPost.css';

const BlogPost = () => {
  const { id } = useParams();
  const post = blogPosts.find(p => p.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!post) {
    return (
      <div className="container text-center section-padding" style={{ paddingTop: '150px' }}>
        <h2>Post not found</h2>
        <Link to="/blog" className="btn-primary">Return to Blog</Link>
      </div>
    );
  }

  return (
    <article className="blog-post-page">
      <div className="container blog-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/blog" className="back-link">
            <i className="fas fa-arrow-left"></i> Back to Insights
          </Link>
          
          <header className="blog-header">
            <h1 className="post-title">{post.title}</h1>
            <div className="post-meta">
              <span className="post-date">
                <i className="far fa-calendar-alt"></i> {post.date}
              </span>
              <span className="post-author">
                <i className="far fa-user"></i> {post.author}
              </span>
            </div>
          </header>

          <div className="glass-panel post-content-wrapper">
            <div 
              className="post-content"
              dangerouslySetInnerHTML={{ __html: post.content }} 
            />
            
            <div className="post-footer">
              <div className="share-text">Share this insight:</div>
              <div className="social-links">
                <button className="social-btn" onClick={() => window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(post.title)}&url=${encodeURIComponent(window.location.href)}`, '_blank')}>
                  <i className="fab fa-twitter"></i>
                </button>
                <button className="social-btn" onClick={() => window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}&title=${encodeURIComponent(post.title)}`, '_blank')}>
                  <i className="fab fa-linkedin-in"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="cta-section text-center mt-5">
            <h3>Ready to apply these insights?</h3>
            <p>Start your journey with LunarLog AI today.</p>
            <div className="cta-buttons">
               <a 
                 href="https://apps.apple.com/us/app/lunarlog-ai-trading-journal/id6755897013" 
                 target="_blank" 
                 rel="noopener noreferrer" 
                 className="cta-button primary"
               >
                 <i className="fab fa-apple"></i> Download on iOS
               </a>
               <Link to="/android-waitlist" className="cta-button secondary">
                 <i className="fab fa-android"></i> Join Android Waitlist
               </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </article>
  );
};

export default BlogPost;

